import Vue from 'vue'
import { ConfirmDialogPlugin, ConfirmDialogOptions } from '@/components/ConfirmDialogPlugin'

const options: ConfirmDialogOptions = {
  property: '$confirm'
}
Vue.use(ConfirmDialogPlugin, options)
